import React from 'react';
import { getStaticPropsHotels } from '@layout/get-page-props';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { GetStaticProps } from 'next';
import { useI18NextContext } from '@components/hooks';
import { PageProps } from '@model/pages';
import { Destination, DestinationsResponse, GeographyApi, Resort, Place } from '@model/iceberg';
import { Page } from '@model/common';
import { HotelsPageLayout } from '@layout/HotelsPageLayout/HotelsPageLayout';

export interface FromPricePageProps extends PageProps {
  cmsConfig: any;
  display: string;
  path: string;
  place: Place;
  airports: Array<string>;
}

const ResortFromPricesPage = (props: FromPricePageProps) => {
  const { display } = props;
  const t: any = useI18NextContext();
  const metaTitle: string = t('seo__resort-listing-page--title', {
    resort: display
  });
  const metaDescription: string = t('seo__resort-listing-page--description', { resort: display });

  return <HotelsPageLayout {...props} metaTitle={metaTitle} metaDescription={metaDescription} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps(
  (store) => async (props: any) => await getStaticPropsHotels(store, props)
);

export async function getStaticPaths() {
  const destinations: DestinationsResponse = await new GeographyApi().getDestinations();
  const resorts: Array<Resort> = destinations.destinations.reduce(
    (acc: Array<Resort>, destination: Destination) => acc.concat(destination.resorts),
    []
  );
  const paths: Array<string> = resorts.map((resort: Resort) =>
    Page.DESTINATION.concat('/').concat(resort.name.path).concat(Page.HOTELS)
  );
  return { paths, fallback: false };
}

export default withGlobalProvider(ResortFromPricesPage);
